angular.module('bmsApp.merrymaids.schedule')
	.controller('MMScheduleWarningsModalCtrl', MMScheduleWarningsModalCtrl);

MMScheduleWarningsModalCtrl.$inject = [
	'$modalInstance',
	'$state',
	'warnings',
	'showFixOptions',
];

function MMScheduleWarningsModalCtrl(
	$modalInstance,
	$state,
	warnings,
	showFixOptions
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		handlers: handlers,
		warnings: warnings,
		showFixOptions: showFixOptions,
	});

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.cancel = () => {
		$modalInstance.dismiss('close');
	}

	handlers.fixWarnings = () => {
		$modalInstance.dismiss('fix');
	}
}
